import React from "react";
import HeaderPortal from "components/portal/header-portal";
import ProjectTagsCombobox from "components/directus/combobox/project-tags";

export default function PerformanceOverviewFilters({
  tagId,
  onChange,
  className = "w-52",
  usePortal = true,
}) {
  const content = (
    <div className="flex items-center gap-2">
      <ProjectTagsCombobox
        value={tagId}
        onChange={onChange}
        placeholder="All Project Tags"
        hideLabel
        className={className}
      />
    </div>
  );

  if (usePortal) {
    return <HeaderPortal>{content}</HeaderPortal>;
  }

  return content;
}
